import { Breadcrumbs } from "../components/common";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "This Privacy Policy is a draft and requires legal review before publication.",
    sections: [
      ["Information we collect", "We collect information you provide through enquiry forms, such as your name, organisation, email and project details."],
      ["How we use information", "Information is used to respond to enquiries, scope projects and communicate about services."],
      ["Data sharing", "We do not sell personal information. Details are shared only as needed to deliver a project you have engaged us for."],
      ["Retention", "Retention and deletion are handled per arrangements confirmed with each client."],
      ["Your choices", "You may contact us to request access to or deletion of the information you have provided."],
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "These Terms of Use are a draft and require legal review before publication.",
    sections: [
      ["Use of this website", "This website is provided for information about Primevanta Global’s services."],
      ["No warranties", "Content is provided in good faith. We do not claim specific accuracy, turnaround or compliance guarantees."],
      ["Intellectual property", "Website content and branding are the property of Primevanta Global."],
      ["Enquiries", "Do not submit confidential records through the general enquiry form."],
    ],
  },
  data: {
    title: "Data Handling Notice",
    intro: "This Data Handling Notice is a draft and requires review and approval before publication.",
    sections: [
      ["Secure transfer", "Sensitive files should be transferred through arrangements agreed during scoping, not the general form."],
      ["Access control", "Project data is handled within controlled workflows appropriate to each engagement."],
      ["Retention & deletion", "Data is retained and deleted per client arrangements."],
      ["No compliance claims", "We do not claim HIPAA, GDPR, ISO or other certifications unless independently established and stated in writing."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: c.title }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Legal</span>
        <h1 className="mt-4 font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[48px]">{c.title}</h1>
        <p className="mt-4 max-w-2xl rounded-xl border border-brand-warning/30 bg-[#FBF6EC] p-4 text-[14px] text-brand-ink">{c.intro}</p>
        <div className="mt-10 max-w-2xl space-y-8">
          {c.sections.map(([t, d]) => (
            <div key={t}>
              <h2 className="font-heading text-[20px] font-700 text-brand-ink">{t}</h2>
              <p className="mt-2 text-[16px] leading-relaxed text-brand-muted">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
